<div class="loading-screen-container" [class.startup]="onStartUp">
    <div fxLayout="row" fxFlexAlign="center" class="spinner-container">
        <mat-spinner id="spinner"></mat-spinner>
    </div>
    <div fxLayout="row" fxFlexAlign="center" class="text-container">
        <h1 i18n="@@loading-label" id="loading-label">Loading...</h1>
    </div>
</div>